import { render, staticRenderFns } from "./claim-view.vue?vue&type=template&id=3d6c71be&scoped=true"
import script from "./claim-view.vue?vue&type=script&lang=js"
export * from "./claim-view.vue?vue&type=script&lang=js"
import style0 from "./claim-view.vue?vue&type=style&index=0&id=3d6c71be&prod&lang=scss"
import style1 from "./claim-view.vue?vue&type=style&index=1&id=3d6c71be&prod&scoped=true&lang=css"
import style2 from "./claim-view.vue?vue&type=style&index=2&id=3d6c71be&prod&lang=css"
import style3 from "./claim-view.vue?vue&type=style&index=3&id=3d6c71be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c71be",
  null
  
)

export default component.exports